import { format } from 'date-fns';
import { es } from 'date-fns/locale';

export const getDaysArray = (_startDate, _endDate) => {
  const daysArray = [];
  const currentDate = new Date(_startDate);

  while (currentDate <= _endDate) {
    const formattedDate = currentDate.toISOString().split('T')[0];
    daysArray.push(formattedDate);
    currentDate.setDate(currentDate.getDate() + 1);
  }

  return daysArray;
};

export const formatSummaryDate = (timestamp) => {
  const date = new Date(timestamp);
  const formattedDate = format(date, "EEEE - dd 'de' MMMM yyyy", { locale: es });

  return formattedDate
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};

export const formatSummaryDateWithHour = (date) => {
  if (!date) return '';

  return format(new Date(date), "dd/MM/yy HH:mm");
};

export const formatSummaryDateWithSeconds = (date) => {
  if (!date) return '';

  return format(new Date(date), "dd/MM/yy HH:mm:ss");
};
